import { useEffect, useState } from 'react';

export const useIsClickStartedFromRef = (ref: React.RefObject<HTMLDivElement>) => {
    const [clickStartedFromRef, setClickStartedFromRef] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const handleMouseDown = (event: MouseEvent) => {
            if (element.contains(event.target as Node)) {
                setClickStartedFromRef(true);
            }
        };

        const handleMouseUp = () => {
            // аснихронная установка флага, чтобы успел отработать onClose
            setTimeout(() => {
                setClickStartedFromRef(false);
            }, 0);
        };

        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [ref]);

    return clickStartedFromRef;
};
